import { CoreString } from "../../../../core/String";
export function sanitizeExportedString(word) {
  word = word.replace(/'/g, "'");
  word = CoreString.escapeLineBreaks(word);
  return word;
}
